import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import Layout from "@/components/Layout";
import { api } from "@/lib/api";
import { fmt, fmtDate } from "@/lib/format";
import { Check, X, Phone } from "lucide-react";

export default function OdemeSozuOnaylar() {
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [busy, setBusy] = useState("");

  const load = useCallback(() => {
    setLoading(true);
    api.get("/cari/odeme-sozu-onaylar").then((r) => setRows(r.data || [])).finally(() => setLoading(false));
  }, []);
  useEffect(() => { load(); }, [load]);

  const decide = async (id, action) => {
    setBusy(id);
    try {
      await api.post(`/cari/odeme-sozu-onaylar/${id}/${action}`);
      toast.success(action === "approve" ? "Değişiklik onaylandı ve uygulandı" : "Değişiklik reddedildi");
      load();
    } catch (e) { toast.error(e.response?.data?.detail || "İşlem başarısız"); } finally { setBusy(""); }
  };

  return (
    <Layout>
      <div className="kicker mb-1">YÖNETİM</div>
      <h1 className="font-heading text-3xl font-bold tracking-tight mb-1">Ödeme Sözü Onayları</h1>
      <p className="text-sm text-[#8C8377] mb-6">Personelin kendi ödeme sözü kayıtlarında yaptığı düzenleme talepleri burada onay bekler. Onaylanmadan mevcut kayıt değişmez.</p>

      <div className="bg-white border border-[#E7DECC] rounded-sm" data-testid="promise-approvals-panel">
        <div className="flex items-center gap-2 px-4 py-3 border-b border-[#E7DECC]">
          <Phone className="w-4 h-4 text-[#7C5E9B]" />
          <span className="font-heading font-bold text-sm">Onay Bekleyen Düzenlemeler</span>
          <span className="ml-1 px-2 py-0.5 rounded-sm text-xs font-semibold bg-[#7C5E9B]/10 text-[#7C5E9B]">{rows.length}</span>
        </div>
        {loading ? (
          <div className="px-4 py-10 text-center text-[#8C8377] text-sm">Yükleniyor...</div>
        ) : rows.length === 0 ? (
          <div className="px-4 py-10 text-center text-[#8C8377] text-sm" data-testid="promise-approvals-empty">Onay bekleyen düzenleme yok.</div>
        ) : (
          <div className="divide-y divide-[#E7DECC]">
            {rows.map((r) => (
              <div key={r.id} className="px-4 py-4" data-testid={`promise-approval-${r.id}`}>
                <div className="flex flex-wrap items-start justify-between gap-3">
                  <div>
                    <div className="font-heading font-bold text-sm">{r.musteri}</div>
                    <div className="text-xs text-[#8C8377]">Talep eden: {r.requested_by_name || r.requested_by} · {fmtDate(r.requested_at)}</div>
                  </div>
                  <div className="flex gap-2">
                    <button disabled={busy === r.id} onClick={() => decide(r.id, "approve")} data-testid={`promise-approve-${r.id}`} className="inline-flex items-center gap-1 px-3 py-1.5 bg-[#2F6E4E] hover:bg-[#2AA249] text-white rounded-sm text-xs font-semibold transition-colors duration-150 disabled:opacity-60"><Check className="w-3.5 h-3.5" /> Onayla</button>
                    <button disabled={busy === r.id} onClick={() => decide(r.id, "reject")} data-testid={`promise-reject-${r.id}`} className="inline-flex items-center gap-1 px-3 py-1.5 border border-[#E7DECC] text-[#8C8377] hover:text-[#A63A3A] rounded-sm text-xs font-semibold transition-colors duration-150 disabled:opacity-60"><X className="w-3.5 h-3.5" /> Reddet</button>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-3 mt-3">
                  <PromiseCard title="MEVCUT" p={r.eski} tone="#8C8377" />
                  <PromiseCard title="YENİ (TALEP)" p={r.yeni} tone="#B8933F" />
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}

function Row({ label, value }) {
  return (
    <div className="flex justify-between gap-3 text-sm py-0.5">
      <span className="text-[#8C8377]">{label}</span>
      <span className="font-medium text-right">{value || "-"}</span>
    </div>
  );
}

function PromiseCard({ title, p, tone }) {
  p = p || {};
  return (
    <div className="border border-[#E7DECC] rounded-sm p-3">
      <div className="kicker mb-2" style={{ color: tone }}>{title}</div>
      <Row label="Görüşme Tarihi" value={p.tarih ? fmtDate(p.tarih) : "-"} />
      <Row label="Temsilci" value={p.temsilci} />
      <Row label="Mahiyet" value={p.mahiyet} />
      <Row label="Taahhüt Tarihi" value={p.taahhut_tarihi ? fmtDate(p.taahhut_tarihi) : "-"} />
      <Row label="Taahhüt Tutarı" value={p.taahhut_tutari ? fmt(p.taahhut_tutari) : "-"} />
      <Row label="Not" value={p.aciklama} />
    </div>
  );
}
